export const UPDATE_NAME = 'UPDATE_NAME';
export const CLEAR_NAME = 'CLEAR_NAME';
